import METHODOLOGYROLES from 'data/mantechcar25/methodology-roles.json';
import {
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import { StyledRecharts } from '../../shared/recharts/Recharts.styled';

const MethodologyRoles: React.FC = () => {
  return (
    <div>
      <StyledRecharts className="methodology">
        <ResponsiveContainer height={330} width="99%" minWidth={400}>
          <BarChart data={METHODOLOGYROLES} layout="vertical">
            <XAxis
              type="number"
              allowDecimals={false}
              tickLine={false}
              padding={{ left: 10 }}
              tickFormatter={(tick) => {
                return `${tick}%`;
              }}
            />
            <YAxis
              type="category"
              dataKey="role"
              tickLine={false}
              width={160}
            />
            <Tooltip
              cursor={{ fill: 'transparent' }}
              labelStyle={{ display: 'none' }}
              separator=""
              formatter={(value: number) => [value.toFixed(1) + '%', '']}
              wrapperClassName="tooltip-x"
            />

            <Bar dataKey="share" barSize={8} radius={5} />
          </BarChart>
        </ResponsiveContainer>
      </StyledRecharts>
    </div>
  );
};

export default MethodologyRoles;
